import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

interface FilterItem {
  id: string;
  name: string;
}

export interface FilterState {
  grades: FilterItem[] | null;
  classes: FilterItem[] | null;
  sites: FilterItem[] | null;
  roadmaps: FilterItem[] | null;
  //classesIdsDefaultValue: string[] | null; // This field only will be populated if the logged user is a teacher
}

interface TeacherDashboardFilterState {
  value: FilterState;
}

const initialState: TeacherDashboardFilterState = {
  value: { grades: null, classes: null, sites: null, roadmaps: null /*classesIdsDefaultValue: null*/ },
};

export const teacherDashboardFilterSlice = createSlice({
  name: 'teacherDashboardFilter',
  initialState,
  reducers: {
    setTeacherDashboardFilter: (state: TeacherDashboardFilterState, action: PayloadAction<FilterState>) => {
      state.value = action.payload;
    },
    resetTeacherDashboardFilters: (state: TeacherDashboardFilterState) => {
      state.value = initialState.value;
    },
  },
});

export const selectedTeacherDashboardFilter = (state: RootState) => state.teacherDashboardFilter.value;

export const { setTeacherDashboardFilter, resetTeacherDashboardFilters } = teacherDashboardFilterSlice.actions;

export default teacherDashboardFilterSlice.reducer;
